import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthContext } from '../../components/AuthProvider';
import AuthLayout from '../../components/auth/AuthLayout';
import AuthInput from '../../components/auth/AuthInput';
import AuthButton from '../../components/auth/AuthButton';
import AuthMessage from '../../components/auth/AuthMessage';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { register, registerError } = useAuthContext();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    register({ email, password }, {
      onSuccess: () => {
        navigate('/login', { state: { message: '注册成功，请登录' } });
      },
    });
  };

  return (
    <AuthLayout title="注册账户">
      <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
        <div className="rounded-md shadow-sm -space-y-px">
          <AuthInput
            type="email"
            value={email}
            onChange={setEmail}
            placeholder="邮箱地址"
            isFirst
          />
          <AuthInput
            type="password"
            value={password}
            onChange={setPassword}
            placeholder="密码"
            isLast
          />
        </div>

        {registerError && (
          <AuthMessage type="error">
            {registerError.message === 'User already registered' 
              ? '该邮箱已被注册，请直接登录'
              : registerError.message}
          </AuthMessage>
        )}

        <div className="flex flex-col space-y-4">
          <AuthButton type="submit">注册</AuthButton>
          <Link 
            to="/login"
            className="text-center text-sm text-indigo-600 hover:text-indigo-500"
          >
            已有账户？点击登录
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
}